import { AxiosInstance } from 'axios';
import { Result } from 'services/Result';
import {
  CreateUpdateTrackmanParameterCategoryRequest,
  ReorderTrackmanParameterCategoriesRequest,
  TrackmanParameterCategoryDto,
} from 'types/admin/trackmanParameterCategories';

const baseUrl = '/api/admin/trackman-parameters/categories';

export class TrackmanParameterCategoriesService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getCategories = async () => {
    const response = await this.axiosInstance.get<Result<TrackmanParameterCategoryDto[]>>(baseUrl);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching parameter categories.');
  };

  createCategory = async (request: CreateUpdateTrackmanParameterCategoryRequest) => {
    const response = await this.axiosInstance.post<Result<TrackmanParameterCategoryDto>>(baseUrl, request);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while creating the category.');
  };

  updateCategory = async (categoryId: string, request: CreateUpdateTrackmanParameterCategoryRequest) => {
    const response = await this.axiosInstance.put<Result<TrackmanParameterCategoryDto>>(`${baseUrl}/${categoryId}`, request);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while updating the category.');
  };

  deleteCategory = async (categoryId: string) => {
    await this.axiosInstance.delete(`${baseUrl}/${categoryId}`);
  };

  reorderCategories = async (request: ReorderTrackmanParameterCategoriesRequest) => {
    await this.axiosInstance.post(`${baseUrl}/reorder`, request);
  };

  sendToTranslation = async (categoryId: string) => {
    const response = await this.axiosInstance.post(`${baseUrl}/${categoryId}/send-to-translation`);
    if (response.status !== 200 && response.status !== 204) {
      throw Error('There was an internal error while sending the category to translation.');
    }
  };

  resyncTranslation = async (categoryId: string, language: string) => {
    const response = await this.axiosInstance.post(`${baseUrl}/${categoryId}/resync-translation/${language}`);
    if (response.status !== 200 && response.status !== 204) {
      throw Error('There was an internal error while resyncing the category translation.');
    }
  };
}

export default TrackmanParameterCategoriesService;
